import React from "react";
import { useOverrides, Override } from "@quarkly/components";
import { Text, Strong, Image, LinkBox, Box, Section } from "@quarkly/widgets";
import RotateImage from "./RotateImage";
const defaultProps = {
	"padding": "68px 0 68px 0",
	"md-padding": "0px 0 28px 0"
};
const overrides = {
	"box": {
		"kind": "Box",
		"props": {
			"empty-border-width": "1px",
			"empty-border-color": "LightGray",
			"md-position": "relative",
			"lg-margin": "0px 0px 0px 0px",
			"empty-min-width": "64px",
			"width": "50%",
			"flex-direction": "column",
			"padding": "0px 120px 0px 0px",
			"lg-padding": "0px 0px 0px 0px",
			"empty-border-style": "solid",
			"margin": "0px 60px 0px 0px",
			"display": "flex",
			"align-items": "flex-start",
			"empty-min-height": "64px",
			"justify-content": "space-between",
			"md-width": "100%"
		}
	},
	"text": {
		"kind": "Text",
		"props": {
			"md-width": "80%",
			"sm-width": "100%",
			"margin": "0px 0px 40px 0px",
			"font": "--headline1",
			"color": "--secondary",
			"lg-font": "normal 500 50px/1.3 \"Marcellus\", serif",
			"lg-margin": "0px 0px 16px 0px",
			"md-font": "normal 500 40px/1.3 \"Marcellus\", serif",
			"children": <>
				Welcome to the{" "}
				<Strong>
					Energize Café
				</Strong>
				{" "}Franchise
			</>
		}
	},
	"text1": {
		"kind": "Text",
		"props": {
			"margin": "0px 0px 60px 0px",
			"font": "--lead",
			"color": "--darkL2",
			"md-font": "normal 400 16px/1.5 \"Marcellus\", serif",
			"md-margin": "0px 0px 32px 0px",
			"children": "We are passionate about providing fresh, organic, and nutritious food options that fuel a healthy lifestyle. As a fast-growing café chain, we offer you the opportunity to join our mission of making wellness accessible to everyone through delicious, plant-based, and energy-boosting meals. Whether you’re looking to bring a vibrant new café to your community or expand an existing business, Energize Café is the perfect franchise opportunity for those committed to health, wellness, and community."
		}
	},
	"linkBox": {
		"kind": "LinkBox",
		"props": {
			"sm-top": "745px",
			"border-color": "--color-secondary",
			"border-radius": "500%",
			"hover-color": "--pageBg",
			"href": "#work",
			"hover-opacity": ".7",
			"padding": "0px 0px 0px 0px",
			"md-bottom": "0px",
			"position": "relative",
			"color": "--secondary",
			"md-width": "100%",
			"md-top": "705px",
			"md-min-height": "110px",
			"align-items": "center",
			"md-position": "absolute",
			"sm-width": "100%"
		}
	},
	"image": {
		"kind": "Image",
		"props": {
			"height": "32px",
			"src": "https://uploads.quarkly.io/615c316435c5c8001f775568/images/arrowbutton.svg?v=2021-11-01T20:27:13.301Z",
			"position": "absolute",
			"width": "32px"
		}
	},
	"rotateImage": {
		"kind": "RotateImage",
		"props": {}
	},
	"box1": {
		"kind": "Box",
		"props": {
			"empty-min-width": "64px",
			"empty-border-style": "solid",
			"md-margin": "0px 0px 0px 0px",
			"md-width": "100%",
			"empty-min-height": "64px",
			"empty-border-width": "1px",
			"empty-border-color": "LightGray",
			"width": "50%",
			"margin": "0px 0px 0px 60px"
		}
	},
	"image1": {
		"kind": "Image",
		"props": {
			"src": "https://images.unsplash.com/photo-1511690656952-34342bb7c2f2?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&h=2000",
			"object-fit": "cover",
			"lg-min-height": "481px",
			"max-height": "616px",
			"width": "100%",
			"object-position": "0% 70%",
			"md-max-height": "410px",
			"md-min-height": "none",
			"md-margin": "0px 0px 150px 0px"
		}
	}
};

const Hero = props => {
	const {
		override,
		children,
		rest
	} = useOverrides(props, overrides, defaultProps);
	return <Section {...rest}>
		<Override slot="SectionContent" md-flex-direction="column" flex-direction="row" />
		<Box {...override("box")}>
			<Text {...override("text")} />
			<Text {...override("text1")} />
			<LinkBox {...override("linkBox")}>
				<Image {...override("image")} />
				<RotateImage {...override("rotateImage")} />
			</LinkBox>
		</Box>
		<Box {...override("box1")}>
			<Image {...override("image1")} />
		</Box>
		{children}
	</Section>;
};

Object.assign(Hero, { ...Section,
	defaultProps,
	overrides
});
export default Hero;